(function () {
	angular
		.module('trackeye')
		.factory('OLFeature', _OLFeatureFactory);

	_OLFeatureFactory.$inject = ['OLCoord'];

	function _OLFeatureFactory(OLCoord) {

		/**
		 *
		 * @param {Device} device
		 * @param {SutMessage} [message]
		 * @constructor
		 */
		function OLFeature(device, message) {
			this.device = device;
			this.message = message || device.latest;
			this.name = device.getUuid();
			this.type = undefined;
			this.coord = message ? new OLCoord(message.getCoord()) : new OLCoord([0, 0, 0]);

			/**
			 * Types supported
			 */
			this.types = ['circle', 'marker'];
			this.defaults = {
				marker_path: 'assets/images/fleet/',
				marker: 'positions-marker.png',
				circle: [76, 181, 248, .5],
				circle_hide: [76, 181, 248, 0]
			};

			this.visible = false;

			this.circleGeom = new ol.geom.Circle(this.coord.getCoord(), this.coord.getRadius());
			this.pointGeom = new ol.geom.Point(this.coord.getCoord());

			this.source = new ol.Feature({
				circleGeom: this.circleGeom,
				pointGeom: this.pointGeom
			});

			this._marker = false;
			this._circle = false;

			this.source.setId(this.name);
		}

		/**
		 * Returns original ol.Feature
		 * @returns {ol.Feature}
		 */
		OLFeature.prototype.getFeature = function () {
			return this.source;
		};

		/**
		 *
		 * @returns {number|string|undefined}
		 */
		OLFeature.prototype.getId = function () {
			return this.source.getId();
		};

		OLFeature.prototype.getName = function () {
			return this.name;
		};

		OLFeature.prototype.getType = function () {
			return this.type;
		};

		OLFeature.prototype.getLat = function () {
			return this.coord.getLat();
		};

		OLFeature.prototype.getLon = function () {
			return this.coord.getLon();
		};

		OLFeature.prototype.getRadius = function () {
			return this.coord.getRadius();
		};

		/**
		 * Set coordinates for the feature
		 * @param {SutMessage} message
		 * @returns {OLFeature}
		 */
		OLFeature.prototype.setCoords = function (message) {
			this.message = message;

			this.coord.setCoords(message.getCoord());

			this.circleGeom.setCenterAndRadius(this.coord.getCoord(), this.coord.getRadius());
			this.pointGeom.setCoordinates(this.coord.getCoord());

			return this;
		};

		/**
		 * Set radius for the feature
		 * @param {number} radius
		 * @returns {OLFeature}
		 */
		OLFeature.prototype.setRadius = function (radius) {
			this.coord.setRadius(radius);
			this.circleGeom.setRadius(radius);

			return this;
		};

		OLFeature.prototype.isCircle = function () {
			return this._circle;
		};

		OLFeature.prototype.isMarker = function () {
			return this._marker;
		};

		OLFeature.prototype.isVisible = function () {
			return this.visible;
		};

		OLFeature.prototype.isHidden = function () {
			return !this.visible;
		};

		OLFeature.prototype.hide = function () {
			this.visible = false;
		};

		OLFeature.prototype.show = function () {
			this.visible = true;
		};

		/**
		 * Sets the feature as a given type
		 * allowed types are defined at OLFeature.types
		 * @param {string} type - Any type that is in OLFeature.types
		 * @param {object} marker - Name of marke if type=icon
		 */
		OLFeature.prototype.is = function (type, marker) {
			if (this.types.indexOf(type) >= 0) {
				this.type = type;
				this["_is_" + type.toLowerCase()](marker);
			} else {
				throw 'Unsupported feature type!';
			}
		};

		OLFeature.prototype._is_marker = function (marker) {
			/**
			 * Position the marker correctly on the map.
			 * due to different sizes of markers
			 */
			var anchor = marker.image ? [0.5, 0.5] : [0.5, 1],
				image = marker.image || this.defaults.marker;

			this.source.setGeometryName('pointGeom');
			this.source.setStyle(new ol.style.Style({
				image: new ol.style.Icon({
					anchor: anchor,
					src: this.defaults.marker_path + image,
					scale: marker.scale || 1
				})
			}));

			this._marker = true;
		};

		OLFeature.prototype._is_circle = function () {
			this.source.setGeometryName('circleGeom');
			this.source.setStyle(new ol.style.Style({
				fill: new ol.style.Fill({
					color: 'rgba(76, 181, 248, .5)'
				}),
				stroke: new ol.style.Stroke({
					color: '#4CB5F8',
					width: 1
				})
			}));

			this._circle = true;
		};

		return OLFeature;
	}
})();